import type { MixpanelSuperProperties } from "./mixpanel_generated/super_properties";
import { getProvider } from "./registry";

// Super properties are registered incrementally (auth state, page_name on nav, etc.), so accept a Partial.
export function registerSuperProperties(props: Partial<MixpanelSuperProperties>): void {
  getProvider()?.register(props);
}
